enum ConfigurePageNavTabRequirement {
  ASSEMBLIES_ENABLED = 'ASSEMBLIES_ENABLED',
  QUOTING_TOOL_AVAILABLE = 'QUOTING_TOOL_AVAILABLE',
  WORKFLOWS_AVAILABLE = 'WORKFLOWS_AVAILABLE',
  DISCOUNTS_ENABLED = 'DISCOUNTS_ENABLED',
  REQS_REVIEW_ENABLED = 'REQS_REVIEW_ENABLED',
}

export default ConfigurePageNavTabRequirement;
